const env = import.meta.env.VITE_ENVIRONMENT;
export const BOT_URL = env === 'prod' ? 'https://t.me/AffileadBot' : 'https://t.me/affilead_stage_bot';
